import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import { Statuses } from "./Competition";


export default function Dashboard({ competitions }) {


    return (
        <App>
            <div className="w-full">
                <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col space-y-7">
                    <div className="flex items-center justify-between">
                        <h1 className="text-3xl font-medium">Competitions</h1>
                        <Link href="/competitions/add" className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Competition</Link>
                    </div>
                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
                        {competitions ? competitions.map((competition) => {
                            const cancelledApplications = competition.applications.filter((app: any) => app.status === Statuses.Error);
                            const paidApplications = competition.applications.filter((app: any) => app.status === Statuses.Paid);
                            const sortedApplications = competition.applications.filter((app: any) => app.status === Statuses.Sorted);
                            const awaitingApplications = competition.applications.filter((app: any) => app.status === Statuses.Awaiting);
                            const doneApplications = competition.applications.filter((app: any) => app.status === Statuses.Ready);


                            return (
                                <div className="border border-gray-300 rounded-lg p-4">
                                    <div className="flex justify-between items-center">
                                        <h2 className="text-xl font-medium">{competition.name}</h2>
                                        <Link href={`/competitions/${competition.id}/edit`} className="text-gray-500 hover:text-gray-700 float-right">
                                            <Pen size={16} />
                                        </Link>
                                    </div>
                                    <p className="text-gray-600 font-small mb-2">{competition.date}</p>
                                    <div className="gap-y-1 mb-4">
                                        <p className="text-gray-600">Applications: {competition.applications.length}</p>
                                        <p className="text-gray-600">Done: {doneApplications.length}</p>
                                        <p className="text-gray-600">Awaiting: {awaitingApplications.length}</p>
                                        <p className="text-gray-600">Cancelled: {cancelledApplications.length}</p>
                                        <p className="text-gray-600">Paid: {paidApplications.length}</p>
                                        <p className="text-gray-600">Sorted: {sortedApplications.length}</p>
                                    </div>
                                    <Link href={`/competitions/${competition.id}`} className="text-indigo-600 hover:text-indigo-800">View Competition</Link>
                                </div>
                            )
                        }) : null}
                    </div>
                </div>
            </div>
        </App>
    )
}